import { render, staticRenderFns } from "./ProposalSearch.vue?vue&type=template&id=2054f73c&scoped=true&"
import script from "./ProposalSearch.vue?vue&type=script&lang=js&"
export * from "./ProposalSearch.vue?vue&type=script&lang=js&"
import style0 from "./ProposalSearch.vue?vue&type=style&index=0&id=2054f73c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2054f73c",
  null
  
)

export default component.exports